export default {
  storage_key: process.env.VUE_APP_STORAGE_KEY,

  set(token, key) {
    localStorage.setItem(`${this.storage_key}_${key}`, token);
  },

  get(key) {
    return localStorage.getItem(`${this.storage_key}_${key}`);
  },

  has(key) {
    return this.get(key) != null;
  },

  remove(key) {
    localStorage.removeItem(`${this.storage_key}` + "_" + key);
  },
};
